import classes from "./PrimaryBanner.module.css";
import React, { useContext, useEffect, useState, memo } from "react";
import AuthContext from "../../store/auth-context";
import { t } from "../../locales/i18n";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import RemoteConfig from "../../services/RemoteConfig";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import Carousel from "../Carousel/Carousel";
import FadeIn from "../FadeIn/FadeIn";
import Helpers from "../../utils/Helpers";
import "../../index.css";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const PRIMARY_BANNER_IMAGES = [
  { name: "first item", src: images.nail7 },
  { name: "3rd image", src: images.nail11 },
  { name: "4th image", src: images.nail10 },
  { name: "2nd item", src: images.nail8 },
];

const PrimaryBanner = (props) => {
  const {} = props || {};
  const isMobile = useCheckIsMobile();

  return (
    <div className={classes.primaryBanner}>
      <img
        className={classes.primaryBannerImg}
        alt={"primary banner"}
        src={images.nail6}
      />

      <div className={classes.bannerImgContent}>
        <p className={classes.shopNameTitle}>{NAIL_SHOP_INFO.name}</p>
        <p className={classes.subText}>{"HEALTHY NAILS, HAPPY YOU"}</p>
        <BookNowBtn
          onClick={() => window.open("/services", "_self")}
          style={classes.callNowBtn}
          title={"MENU SERVICE"}
        />
        <p className={classes.phoneNum}>{NAIL_SHOP_INFO.phone}</p>
        <p className={classes.shopNameTitle}>{NAIL_SHOP_INFO.address}</p>
      </div>

      <div className={classes.carouselContainer}>
        <FadeIn>
          <Carousel
            animationHandler="slide"
            swipeable={true}
            renderArrowPrev={() => null}
            renderArrowNext={() => null}
            renderIndicator={() => null}
            interval={10000}
            width={isMobile ? "200px" : "25rem"}
            height={isMobile ? "200px" : "25rem"}
          >
            {Helpers.isArrayAvailable(PRIMARY_BANNER_IMAGES)
              ? PRIMARY_BANNER_IMAGES.map((item, index) => {
                  const { name, src } = item || [];
                  return (
                    <div
                      key={`${name + index}`}
                      className={classes.carouselItem}
                    >
                      <img alt={name} src={src} />
                    </div>
                  );
                })
              : null}
          </Carousel>
        </FadeIn>
      </div>
    </div>
  );
};

export default memo(PrimaryBanner);
